module.exports = __webpack_public_path__ + "ac908d07faf4ed6da98a6e28ff5f5267.pdf";